/**
 * Cross-app channel for live edits to the in-flight EventComposer draft.
 *
 * The shell hosts the EventComposer; MFEs (schedule, office, etc.) render
 * surfaces that visualize the same event being edited (e.g. the meeting-rooms
 * grid block). This channel lets either side push field-level deltas so the
 * other can mirror them without owning the draft state itself.
 *
 * Open/close of the composer is **not** carried on this channel — that goes
 * through the canonical `event` query param (see `eventParam.ts`). This
 * channel only carries live patches while the composer is already open.
 *
 * ******* DO NOT MAKE BACKWARDS INCOMPATIBLE CHANGES *******
 * Shell and apps deploy independently. Renaming the channel constant or
 * removing a payload field can silently break listeners or emitters that have
 * not yet been redeployed.
 *
 * Safe changes:
 *   - Add a new optional field to `EventDraftPatch`.
 *   - Add a new well-known origin value (origins are free-form strings).
 *
 * Unsafe changes:
 *   - Rename or remove the channel constant.
 *   - Remove or rename a field on `EventDraftPatch`.
 *   - Change a field's type or semantics.
 *
 * If an incompatible change is unavoidable, introduce a new constant
 * (`dashboard:event-draft:patch:v2`) and run both for at least one release.
 */
/** The window CustomEvent name used as the transport. */
export var EVENT_DRAFT_CHANNEL = 'dashboard:event-draft:patch';
